import { useCallback, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { TagSummaryVersionsModal } from '@/components/ConferenceTag.Summary/Modal.Versions';
import type { ConferenceTagSummaryItem } from '@/types/conferences.tags';
import { ToggleTagSumaryVersionsContext } from './context';

type Props =
  IProjectId &
  ChildrenProps;

export const ProjectSummaryVersionsContainer = ({ projectId, children }: Props) => {
  const api = useChatApiClient();

  const [openItem, setOpenItem] = useState<ConferenceTagSummaryItem>();

  const tagSummaryId = openItem?.summary?.id;

  const {
    data,
  } = useQuery({
    queryKey: ['get:project:tag-summaries:versions', {
      projectId,
      tagSummaryId,
    }], queryFn: ({ queryKey }) => {
      return api.projects.getTagSummaryVersions({
        projectId,
        tagSummaryId,
      });
    }, enabled: !!tagSummaryId, refetchOnWindowFocus: false, placeholderData: {
      items: [],
    },
  });

  const handleOpen = useCallback((item: ConferenceTagSummaryItem) => {
    setOpenItem(item);
  }, []);

  const handleClose = useCallback(() => {
    setOpenItem(null);
  }, []);

  const open = !!tagSummaryId;

  return (
    <ToggleTagSumaryVersionsContext.Provider value={handleOpen}>
      {children}
      {open && (
        <TagSummaryVersionsModal
          open={open}
          onClose={handleClose}
          versions={data.items}
          summaryItem={openItem} />
      )}
    </ToggleTagSumaryVersionsContext.Provider>
  );
};
